import { render, staticRenderFns } from "./MessageStack.vue?vue&type=template&id=528c1f41&scoped=true&"
import script from "./MessageStack.vue?vue&type=script&lang=js&"
export * from "./MessageStack.vue?vue&type=script&lang=js&"
import style0 from "./MessageStack.vue?vue&type=style&index=0&id=528c1f41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528c1f41",
  null
  
)

export default component.exports